import type { ReleaseNoteCategory } from "@a7y/types";

export const CATEGORY_OPTIONS: { value: ReleaseNoteCategory; label: string }[] = [
  { value: "NEW_FEATURE", label: "New Feature" },
  { value: "IMPROVEMENT", label: "Improvement" },
  { value: "FIX", label: "Fix" },
];

export const CATEGORY_BADGE_COLOR: Record<
  ReleaseNoteCategory,
  "violet" | "emerald" | "amber"
> = {
  NEW_FEATURE: "violet",
  IMPROVEMENT: "emerald",
  FIX: "amber",
};

export const CATEGORY_LABEL: Record<ReleaseNoteCategory, string> = {
  NEW_FEATURE: "New Feature",
  IMPROVEMENT: "Improvement",
  FIX: "Fix",
};
